const TAU = Math.PI * 2;

const normalizeAngle = (angle) => {
  // Retorna el ángulo en [0, 2π)
  return (angle % TAU + TAU) % TAU;
};

const angleDistance = (a, b) => {
  const diff = Math.abs(normalizeAngle(a) - normalizeAngle(b));
  return Math.min(diff, TAU - diff);
};

const ANGLE_TOLERANCE = 0.19;

const areAnglesWithin = (angle_a, angle_b)=> angleDistance(angle_a, angle_b) <= ANGLE_TOLERANCE

export { angleDistance, areAnglesWithin }